export default {"src":"/_next/static/media/flexi-limits.4b0cff4a.svg","height":200,"width":200};